import { render, staticRenderFns } from "./StockChart.vue?vue&type=template&id=4d7d2f4e&scoped=true"
import script from "./StockChart.vue?vue&type=script&lang=js"
export * from "./StockChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7d2f4e",
  null
  
)

export default component.exports